var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { useDebounce } from "use-debounce";
export var useSearchPlaylistForm = function () {
    var _a = __read(React.useState(""), 2), title = _a[0], setTitle = _a[1];
    var _b = __read(React.useState({ type: "public", id: null }), 2), client = _b[0], setClient = _b[1];
    var _c = __read(React.useState('order'), 2), orderBy = _c[0], setOrderBy = _c[1];
    var _d = __read(React.useState('asc'), 2), orderByDirection = _d[0], setOrderByDirection = _d[1];
    var _e = __read(useDebounce(title, 1000), 1), playlistTitle = _e[0];
    var changeTitle = function (evt) {
        return setTitle(evt.target.value);
    };
    var changeType = function (evt) {
        var value = evt.target.value;
        if (value === "public" || value === "any") {
            setClient({ id: null, type: value });
        }
        else if (value === "private") {
            setClient(__assign(__assign({}, client), { type: value }));
            setOrderBy('updated_at');
            setOrderByDirection('desc');
        }
        else {
            setClient({ id: null, type: "any" });
        }
    };
    var changeClient = function (payload) {
        var _a;
        setClient(__assign(__assign({}, client), { id: (_a = payload === null || payload === void 0 ? void 0 : payload.id) !== null && _a !== void 0 ? _a : null }));
    };
    var form = {
        title: playlistTitle,
        type: client.type,
        clientId: client.id,
        orderBy: orderBy,
        orderByDirection: orderByDirection
    };
    var showClientField = client.type === "private";
    return {
        form: form,
        title: { value: title, onChange: changeTitle },
        type: { value: client.type, onChange: changeType },
        client: { value: client.id, onChange: changeClient },
        showClientField: showClientField,
    };
};
